import { authDict } from "@/utils/authDiact";

const permissionDisableDirective = function (Vue) {
  Vue.directive("permission-disable", {
    inserted(el, binding) {
      setDisabled(el, binding);
    },
    componentUpdated(el, binding) {
      setDisabled(el, binding);
    },
  });

  function setDisabled(el, binding) {
    let needAuthRole = binding.value;
    const haveAuthRole = window.localStorage.getItem("authRole")
      ? JSON.parse(window.localStorage.getItem("authRole"))
      : null;
    const noPermission =
      needAuthRole && authDict[haveAuthRole] < authDict[needAuthRole];

    // Element UI 按钮禁用
    if (el.classList.contains("el-button")) {
      el.setAttribute("disabled", noPermission ? "disabled" : false);
      if (noPermission) {
        el.classList.add("is-disabled");
      } else {
        el.classList.remove("is-disabled");
      }
    }
    // 原生button禁用
    if (el.tagName === "BUTTON") {
      el.disabled = !!noPermission;
    }

    if (el.tagName === "INPUT" && el.type === "checkbox") {
      el.disabled = true;
    } else {
      // 查找内部的input元素（针对Element UI的Switch组件结构）
      const inputEl = el.querySelector('input[type="checkbox"]');
      if (inputEl) {
        inputEl.disabled = true;
      }

      // // Element UI Switch禁用
      // if (el.classList.contains('el-switch')) {
      //     const input = el.querySelector('input[type="checkbox"]');
      //     if (input) input.disabled = !!noPermission;
      //     if (noPermission) {
      //         el.classList.add('is-disabled');
      //     }
      //     // else {
      //     //     el.classList.remove('is-disabled');
      //     // }
      // }
    }
  }
};

export default permissionDisableDirective;
